<div class="input-textarea" [style.width]="width" [style.margin-bottom]="displayErrors ? 0 : messagePad">
  <div class="p-field">
    <div class="label-container" *ngIf="label">
      <label [for]="name">{{ label }}<app-label-icon *ngIf="labelIcon" [data]="labelIcon" /></label>
      <span *ngIf="value">{{ hint }}</span>
    </div>
    <textarea
      #input
      appReadOnly
      #model="ngModel"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      [rows]="rows"
      [cols]="cols"
      [id]="name"
      [attr.name]="name"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="isDisabled"
      [class.has-errors]="displayErrors"
      [class.resizable]="resize"
      [class.dirty]="dirty"
      pInputTextarea
      (blur)="onBlur()"
      pInputTextarea
      [attr.aria-invalid]="displayErrors"
      [attr.aria-describedby]="displayErrors ? name + '-error' : null"
      [tabindex]="tabindex"
      [ignoreReadOnly]="ignoreReadOnly"
    ></textarea>
    <div
      class="error-container"
      *ngIf="displayErrors"
      [attr.id]="name + '-error'"
      [style.width]="width"
      role="alert"
      aria-atomic="true"
    >
      <span *ngFor="let error of errors" class="p-error">{{ error }}</span>
    </div>
  </div>
</div>
